import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCircleXmark, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { RootState } from '../../../store';
import SearchResult from './SearchResult';
import {
  RequestStatus,
  setSelectedSearchResult,
  setMode,
  Mode,
} from '../../../store/textPanelContent';
import LoadingIndicator from '../../LoadingIndicator';
import useURLManipulator from '../../../hooks/useURLManipulator';

import styles from './SearchResultItems.module.css';
import { SearchListItem } from '../../../types/searchResult';

interface Props {
  items: SearchListItem[] | undefined;
  requestStatus: RequestStatus;
}

const SearchResultItems = ({ items, requestStatus }: Props): JSX.Element => {
  const dispatch = useDispatch();
  const { updateChapterVerseForSearchResult } = useURLManipulator();
  const { searchInput, selectedSearchResult, mode } = useSelector(
    (state: RootState) => state.textPanelContent
  );
  const { darkMode } = useSelector((state: RootState) => state.settings);

  const containerClass = `${styles.innerContainer} ${
    requestStatus === RequestStatus.init ? styles.fadeOut : ''
  }`;

  // console.log("SearchResultItems", requestStatus);

  return (
    (requestStatus === RequestStatus.loading && <LoadingIndicator />) ||
    (requestStatus === RequestStatus.init && (
      <div className={containerClass}>
        <FontAwesomeIcon className={styles.icon} icon={faMagnifyingGlass} />
        <div className={styles.text}>Search for a topic or passage</div>
      </div>
    )) ||
    (requestStatus === RequestStatus.succeeded && items !== undefined && items.length > 0 && (
      <>
        {items.map(result => {
          const select = () => {
            if (selectedSearchResult === result.id) {
              return;
            }

            dispatch(setSelectedSearchResult(result.id));

            if (result.chapter && result.verse) {
              updateChapterVerseForSearchResult(
                result.chapter,
                result.verse,
                result.textVersion,
                result.bookCode
              );

              if (mode !== Mode.search) {
                dispatch(setMode(Mode.search));
              }
            }
          };

          return (
            <SearchResult
              id={result.id}
              key={`${result.id}-${result.textVersion}-${result.reference}`}
              darkMode={darkMode}
              text={result.text}
              reference={result.reference}
              highlightedText={
                requestStatus === RequestStatus.succeeded
                  ? searchInput.toLowerCase().split(' ')
                  : []
              }
              select={select}
              isSelected={selectedSearchResult === result.id}
            />
          );
        })}
      </>
    )) || (
      <div className={containerClass}>
        <FontAwesomeIcon className={styles.icon} icon={faFileCircleXmark} />
        <div className={styles.text}>No results found</div>
        <div className={styles.secondaryText}>Please try again</div>
      </div>
    )
  );
};

export default SearchResultItems;
